<div class=" container mw-100 group-company-div visible-xs ">
    <nav class="navbar navbar-expand-lg navtext visible-flex-xs transparent p-0">
    <a class="navbar-brand" ><img src="/images/BHP_white.svg" alt="customlogo" width="50.65px" height="22px"></a>
    <a class="navbar-brand"><img src="/images/right_arrow.svg" alt="customlogo" width="24px" height="24px"></a>
  <span class="position-absolute group-company-dropdown text-white "><b>Inventory Management</b></span>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="nav-item dropdown position-absolute" style="right:0">
      <span name='account' class=" nav-link nav-border rounded-0 dropbtn" role="button" id="navbarDropdown3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></span>
      <div class="dropdown-menu account-dropdown mobdrop dropdown-content" aria-labelledby="navbarDropdown" >
       <!-- <h5 (click)="goToUpdatePersonalDetails()" [routerLink]="['profile/my-account/update-personal-details']"><a class="anchor-tag strong">Update Personal details</a></h5>
       <hr>
       <h5 (click)="goToResetPassword()" [routerLink]="['profile/my-account/change-password']" ><a class="anchor-tag strong">Reset Password</a></h5>
       <hr> -->
       <h5 [routerLink]="{ cxRoute : 'logout' } | cxUrl"><a class="anchor-tag strong">Logout</a></h5>
      </div>
</div>
</div>
</nav>

</div>
<div class='hidden-xs container mobile-inv'>
	<div class="hidden-xs-inv   navtext mobile-view-div d-flex justify-content-between">
		<div class="bhp-mobile"> 
      <a class="navbar-brand"><img src="/images/BHP_white.svg" alt="customlogo"><img src="/images/right_arrow.svg" alt="customlogo" ><span class=" group-company-dropdown mobile-management text-white "><b>Inventory Management</b>
      </span></a>
</div>
<div class="nav-item dropdown inline-flex nav-icon-mobile-view">
    <span name='ipadaccount' class=" user-account-icon-btn " id="navbarDropdown5" role="button" aria-haspopup="true" aria-expanded="false">
      <!--<i class="fas fa-user-circle icon-style-mobile ipad-orientation fa-2x fa-mobile-icon"></i>-->
                </span>
              </div>
	</div>
   
</div>
<app-inventory-breadcrumb [navigationData]="navigationData" [pageTitle]="title">
</app-inventory-breadcrumb>
<div class="container d-flex justify-content-center py-5">
    <form (ngSubmit)="onSubmit()" class="form-adjust" [formGroup]="updateForm" >
      <div class="form-group" >
        <label>
          <span class=" strong" >Username*</span>
         
          <input
            type="name"
            class="form-control form-control-lg text-secondary "
            formControlName="username"
            placeholder="Enter username"
          />
         
        </label>
        <cx-form-errors *ngIf="!updateForm.controls.username.errors?.pattern" [control]="updateForm.get('username')"></cx-form-errors>
         <p *ngIf="updateForm.controls.username.errors?.pattern && updateForm.controls.username.dirty"
        class="cx-form-errors pl-0"><i class=" text-danger fas fa-exclamation-circle mr-1 "></i> <span>Invalid pattern</span> </p>
      </div>
      <div class="form-group">
        <label>
          <span class=" strong">New password*</span>
          <input
            type="password" name="newPassword"
            class="form-control form-control-lg text-secondary  mt-2"
            placeholder="New password" formControlName="newPassword"
          
          />
         </label>
         <cx-form-errors *ngIf="!updateForm.controls.newPassword.errors?.pattern" [control]="updateForm.get('newPassword')"></cx-form-errors>
         <p *ngIf="updateForm.controls.newPassword.errors?.pattern && updateForm.controls.newPassword.dirty"
        class="cx-form-errors pl-0"><i class=" text-danger fas fa-exclamation-circle mr-1 "></i> <span>Invalid pattern</span> </p>
      </div>
      <div class="form-group">
        <label>
          <span class=" strong">Confirm new password*</span>
          <input
            type="password" name="newPasswordConfirm"
            class="form-control form-control-lg text-secondary  mt-2" formControlName="newPasswordConfirm" 
            placeholder="Confirm new password"
            
          />
          <cx-form-errors [control]="updateForm.get('newPasswordConfirm')"></cx-form-errors>
        </label>
      </div>
     
      <button type="submit" class="btn btn-lg btn-block btn-primary rounded-1 md-font">
        Submit
      </button>
      <button class="btn btn-lg btn-block btn-link" (click)="backToLogin()">
             Back
            </button>
    </form>
  </div>
  
